import { render, staticRenderFns } from "./TalentRatingsSummaryTab.vue?vue&type=template&id=1e892a95&scoped=true"
import script from "./TalentRatingsSummaryTab.vue?vue&type=script&lang=js"
export * from "./TalentRatingsSummaryTab.vue?vue&type=script&lang=js"
import style0 from "./TalentRatingsSummaryTab.vue?vue&type=style&index=0&id=1e892a95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e892a95",
  null
  
)

export default component.exports